import { IDuplicateCaseRepository } from '../ports/outbound/IDuplicateCaseRepository';

/**
 * The third answer to a duplicate, beside continue and abandon: the case E-Verify reported IS this
 * employee's, typically because a create that timed out here still reached DHS. The API re-reads the
 * case from E-Verify, records it against this I-9 and resolves the duplicate.
 */
export class LinkExistingCaseUseCase {
  constructor(private readonly repository: IDuplicateCaseRepository) {}

  async execute(everifyCaseDuplicateId: string, everifyDuplicateCaseLookupId: string): Promise<void> {
    return this.repository.linkExistingCase(everifyCaseDuplicateId, everifyDuplicateCaseLookupId);
  }
}
